export default "__VITE_ASSET__Bxo8Q$_l__"